import React from 'react'

export const Gallery = () => {
  return (
    <div>
    <div className='galery'>
        <div className='container-fluid text-center bg-dark p-3'>
            <h2>Our Latest Projects</h2>
            <p>Here is our latest projects. You'll love them!</p>
        </div>
    <div class="gallery bg-dark">
        <div class="gallery-item">
            <img src="g1.jpg" alt="Image 1"/>
            <div class="overlay">Project 1</div>
        </div>
        <div class="gallery-item">
            <img src="g2.jpg" alt="Image 2"/>
            <div class="overlay">Project 2</div>
        </div>
        <div class="gallery-item">
            <img src="g3.jpg" alt="Image 3"/>
            <div class="overlay">Project 3</div>
        </div>
        <div class="gallery-item">
            <img src="g4.jpg" alt="Image 4"/>
            <div class="overlay">Project 4</div>
        </div>
        <div class="gallery-item">
            <img src="g5.jpg" alt="Image 4"/>
            <div class="overlay">Project 5</div>
        </div>
        <div class="gallery-item">
            <img src="g6.jpg" alt="Image 4"/>
            <div class="overlay">Project 6</div>
        </div>
        <div class="gallery-item">
            <img src="g7.jpg" alt="Image 4"/>
            <div class="overlay">Project 7</div>
        </div>
        <div class="gallery-item">
            <img src="g8.jpg" alt="Image 4"/>
            <div class="overlay">Project 8</div>
        </div>
        <div class="gallery-item">
            <img src="g9.jpg" alt="Image 4"/>
            <div class="overlay">Project 9</div>
        </div>
        <div class="gallery-item">
            <img src="g10.jpg" alt="Image 4"/>
            <div class="overlay">Project 10</div>
        </div>
    </div>
    </div>
    </div>
  )
}
